import { AccountCircleOutlined } from '@mui/icons-material';
import { EntityHistoryEventGroup } from '../entity-history-timeline.types';
import { EntityHistoryTimelineEvent } from '../entity-history-timeline-event/entity-history-timeline-event.component';
import { useEntityHistoryGroupStyles } from './entity-history-timeline-group.styles';

export function EntityHistoryTimelineGroup({ group, isLast }: { group: EntityHistoryEventGroup; isLast: boolean }) {
  const classes = useEntityHistoryGroupStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <span className={classes.operationLabel}>
          {group.operation?.label || group.operation?.name || group.events[0]?.eventType}
        </span>
        {group.actor?.displayName && (
          <div className={classes.actor}>
            <span className={classes.actorName}>{group.actor.displayName}</span>
            <AccountCircleOutlined className={classes.actorIcon} />
          </div>
        )}
      </div>
      <div className={classes.events}>
        {group.events.map((event, index) => (
          <EntityHistoryTimelineEvent key={event.id} event={event} isLast={index === group.events.length - 1} />
        ))}
      </div>
      {!isLast && <div className={classes.divider} />}
    </div>
  );
}
